import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-title"
}
const _hoisted_2 = { class: "page-title-options" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_check_field = _resolveComponent("check-field")!
  const _component_search_field = _resolveComponent("search-field")!

  return (_ctx.org)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_router_link, {
          class: "goback treebal-arrow-left-bold",
          to: { name: 'Home' }
        }),
        _createElementVNode("h1", null, _toDisplayString(_ctx.org.name), 1),
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isMembersRoute)
            ? (_openBlock(), _createBlock(_component_check_field, {
                key: 0,
                class: "md-down-visible",
                state: _ctx.membersVerified,
                "onUpdate:state": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.membersVerified) = $event)),
                titleNoFilter: 
          _ctx.$t('organization.members.filters.verified.labels.no-filter')
        ,
                titleChecked: 
          _ctx.$t('organization.members.filters.verified.labels.checked')
        ,
                titleUnchecked: 
          _ctx.$t('organization.members.filters.verified.labels.unchecked')
        
              }, null, 8, ["state", "titleNoFilter", "titleChecked", "titleUnchecked"]))
            : _createCommentVNode("", true),
          (_ctx.isMembersRoute)
            ? (_openBlock(), _createBlock(_component_search_field, {
                key: 1,
                class: "md-down-visible",
                placeholder: _ctx.$t(`global.search`),
                search: _ctx.membersSearch,
                "onUpdate:search": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.membersSearch) = $event))
              }, null, 8, ["placeholder", "search"]))
            : _createCommentVNode("", true),
          (_ctx.isAdminsRoute)
            ? (_openBlock(), _createBlock(_component_search_field, {
                key: 2,
                class: "md-down-visible",
                placeholder: _ctx.$t(`global.search`),
                search: _ctx.adminsSearch,
                "onUpdate:search": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.adminsSearch) = $event))
              }, null, 8, ["placeholder", "search"]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "custom-actions")
        ])
      ]))
    : _createCommentVNode("", true)
}